import { defineStore } from "pinia";
import { ref } from "vue";
import Api from "@/model/api";

export const useMidStore = defineStore("mid", () => {
  const mid = ref("");

  let midPromise = null;

  const useMid = async () => {
    if (mid.value && isValidUUID(mid.value)) {
      try {
        const exists = await Api.checkMidExists(mid.value);
        if (exists) return mid.value;
        mid.value = "";
        localStorage.removeItem("mid");
      } catch (error) {
        console.error("Error checking mid existence:", error);
      }
    }

    if (midPromise) return midPromise;

    midPromise = (async () => {
      const localStorageMid = localStorage.getItem("mid");
      if (isValidUUID(localStorageMid)) {
        try {
          const exists = await Api.checkMidExists(localStorageMid);
          if (exists) {
            mid.value = localStorageMid;
            return mid.value;
          }
          localStorage.removeItem("mid");
        } catch (error) {
          console.error("Error checking localStorage mid existence:", error);
        }
      }

      try {
        const fetchedMid = await Api.fetchMid();
        mid.value = fetchedMid;
        localStorage.setItem("mid", mid.value);
        return mid.value;
      } catch (error) {
        console.error("Error in useMid:", error);
        throw error;
      } finally {
        midPromise = null;
      }
    })();

    return midPromise;
  };

  const isValidUUID = (uuid) => {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
  };

  return { useMid };
});
